import DeviceDropdown from '../dashboard/DeviceDropdown';
import IntervalButtons from '../dashboard/IntervalButtons';
import LoadingMessage from '../common/LoadingMessage';
import ErrorMessage from '../common/ErrorMessage';
import AlertsChart from './AlertsChart';
import { useAlertData } from '../../hooks/useAlertData';

function AlertsDashboard({ selectedDevice, onDeviceChange, selectedInterval, customRange, onIntervalChange, onRangeChange }) {
    const { alerts, meta, loading, error, lastUpdated, refresh } = useAlertData(selectedDevice, selectedInterval, customRange);
    const hasSelection = Boolean(selectedDevice);
    const hasData = Array.isArray(alerts) && alerts.length > 0;

    return (
        <div className="dashboard-content">
            <header style={{ marginBottom: '20px' }}>
                <h2>Alerts</h2>
                <p className="section-intro">
                    Review alert events captured for a device across the selected time window. Use the controls below to pick a device and interval, then inspect alert volumes grouped by code.
                </p>
            </header>

            <section className="data-controls">
                <div className="data-controls__layout">
                    <div className="data-controls__device">
                        <div className="data-controls__title">Data analysis controls</div>
                        <DeviceDropdown selectedDevice={selectedDevice} onDeviceChange={onDeviceChange} />
                    </div>
                    <span className="data-controls__divider" aria-hidden="true" />
                    <div className="data-controls__interval">
                        <div className="data-controls__interval-label">Data interval</div>
                        <IntervalButtons
                            selectedInterval={selectedInterval}
                            onIntervalChange={onIntervalChange}
                            customRange={customRange}
                            onCustomRangeChange={onRangeChange}
                        />
                    </div>
                </div>
            </section>

            <div style={{ marginTop: '16px', display: 'flex', gap: '12px', alignItems: 'center' }}>
                <button
                    type="button"
                    onClick={refresh}
                    disabled={!hasSelection || loading}
                    className="refresh-button"
                >
                    🔄 Refresh
                </button>
                {lastUpdated && <span className="refresh-meta">Last updated: {lastUpdated.toLocaleTimeString()}</span>}
                {!hasSelection && !loading && !error && (
                    <span className="refresh-meta">Select a device to load alert data.</span>
                )}
                {meta?.count !== undefined && (
                    <span className="refresh-meta">Total alerts: {meta.count}</span>
                )}
            </div>

            {error && (
                <div style={{ marginTop: '20px' }}>
                    <ErrorMessage message={error} title="Failed to load alerts" />
                </div>
            )}

            {loading && (
                <div style={{ marginTop: '30px' }}>
                    <LoadingMessage message={hasSelection ? 'Loading alerts…' : 'Select a device to load alert data.'} />
                </div>
            )}

            {!loading && !error && hasSelection && (
                <div style={{ marginTop: '24px' }}>
                    {hasData ? (
                        <AlertsChart items={alerts} />
                    ) : (
                        <p>No alerts detected for the selected period.</p>
                    )}
                </div>
            )}
        </div>
    );
}

export default AlertsDashboard;
